import { ReactElement, Suspense, lazy } from 'react';

import { useApiRequest } from '~/hooks/api';
import Loader from '~/ui/components/common/Loader';
import { useStoreActions } from '~/store/hooks';
import styles from './Visits.module.scss';

const VisitsHeader = lazy(() => import('./components/VisitsHeader'));
const VisitsTable = lazy(() => import('./components/VisitsTable'));
const VisitsTiles = lazy(() => import('./components/VisitsTiles'));
const PastVisitsTable = lazy(() => import('./components/PastVisits/PastVisitsTable'));

const Visits = (): ReactElement => {
  const onGetMyClinic = useStoreActions(actions => actions.clinic.onGetMyClinic);

  useApiRequest(() => onGetMyClinic());

  return (
    <Suspense fallback={<Loader />}>
      <div className={styles.container}>
        <VisitsHeader />
        <VisitsTiles />
        <VisitsTable />
        <PastVisitsTable />
      </div>
    </Suspense>
  );
};

export default Visits;
